module.exports = __webpack_public_path__ + "img/mo.222db212.svg";